var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounUser697795(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.2,63.7l-9,2.7c-5.9,1.8-10.8,5.8-13.6,11.2L9.8,83c-1.2,2.3,0.4,5,3,5h70.1c2.6,0,4.2-2.8,3-5L83,77.6   c-2.9-5.4-7.8-9.4-13.6-11.2l-9-2.7c-2.6-0.8-4.1-3.6-3.2-6.2c0.2-0.5,0.5-1,0.8-1.5l5.9-9.2c2.3-3.6,3.2-8,2.6-12.2l-0.9-5.6   c-0.7-4.7-3.3-8.9-7.2-11.7c-6.3-4.5-14.9-4.4-21.1,0.3l0,0c-3.4,2.6-5.8,6.3-6.6,10.5l-1.2,6c-0.9,4.5-0.1,9.2,2.4,13.1l5.6,8.8   c0.4,0.4,0.7,0.9,0.8,1.5C39.3,60,37.9,62.9,35.2,63.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounUser697795);
export default __webpack_public_path__ + "static/media/noun_user_697795.b24cd56c.svg";
export { ForwardRef as ReactComponent };